import usePrivateAxios from '@/common/api/usePrivateAxios'
import { EstablishmentCompanyData } from '@/common/types/establishment/company.type'
import { getRailsUpdate } from '@/common/utils/getRailsUpdate'
import { mapToDeletion } from '@/common/utils/railsHelpers'
import { unFormatCurrency, unFormatPercentage } from '@/common/utils/unFormatters'
import { UpdatePoliticsFinancialValidationSchema } from '@/features/establishments/schemas/politics/updateFinancial.schema'
import { useMutation } from '@tanstack/react-query'

interface UseUpdateEstablishmentFinancialPoliticsProps {
  establishmentCompany?: EstablishmentCompanyData;
  onSuccess?: (response: any) => void
  onError?: (error: any) => void
}

export const useUpdateEstablishmentFinancialPolitics = ({ establishmentCompany, onSuccess, onError }: UseUpdateEstablishmentFinancialPoliticsProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateEstablishmentFinancialPolitics', establishmentCompany?.id],
    mutationFn: async (form: UpdatePoliticsFinancialValidationSchema) => {
      const payload = {
        payment_advance_daily_interest: form?.payment_advance_daily_interest
          ? unFormatPercentage(form?.payment_advance_daily_interest)
          : undefined,
        payment_advance_min_total_to_be_paid: form?.payment_advance_min_total_to_be_paid
          ? unFormatCurrency(form?.payment_advance_min_total_to_be_paid)
          : undefined,
        bank_account_information_attributes: {
          account: form.bank_account_information.account,
          agency: form.bank_account_information.agency,
          bank_institution_id: form.bank_account_information?.bank_institution?.value,
          payee_name: form.bank_account_information.payee_name,
        },
        capture_methods_attributes: getRailsUpdate(
          establishmentCompany?.matrix_branch?.capture_methods || [],
          form.capture_methods || [],
          (x) => x.capture_method.id,
          (x) => x.value,
          mapToDeletion,
          (item: { value: string; }) => ({ capture_method_id: item.value }),
        ),
      };

      return privateAxios.put(`/establishment/company_branches/${establishmentCompany?.matrix_branch_id}/update_financial_information`, { company_branch: payload });
    },
    onSuccess,
    onError,
  })
}
